import { useCallback } from 'react';

import useFetch from 'hooks/useFetch';

import { USERS_API } from './constants';
import type {
    FetchUser,
    PagedResponseOrganizationMember,
    UpdateUserActiveStatus,
    User
} from './types';

const useUsers = () => {
    const { authenticatedGet, authenticatedPut } = useFetch();

    const fetchTeamMembers = useCallback(
        async (pageToken?: string | null, pageSize = 10) => {
            const pageTokenQuery = pageToken ? `&pageToken=${pageToken}` : '';

            const uri = `${USERS_API}?size=${pageSize}${pageTokenQuery}`;

            const response = await authenticatedGet<PagedResponseOrganizationMember>(uri, null);

            return response;
        },
        [authenticatedGet]
    );

    const fetchUser: FetchUser = useCallback(
        async ({ userId }) => {
            const usersUrl = `${USERS_API}/${userId}`;

            return await authenticatedGet<User>(usersUrl, null);
        },
        [authenticatedGet]
    );

    const updateUserActiveStatus: UpdateUserActiveStatus = useCallback(
        async ({ isBlocked, userId }) => {
            const usersUrl = `${USERS_API}/${userId}/blocked`;

            return await authenticatedPut(usersUrl, JSON.stringify({ blocked: isBlocked }));
        },
        [authenticatedPut]
    );

    return {
        fetchTeamMembers,
        fetchUser,
        updateUserActiveStatus
    };
};

export default useUsers;
